import { Component } from '@angular/core';

@Component({
  templateUrl: './add-points.page.html',
})
/**
 * Add points page
 */
export class AddPointsPage {}
